export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Notification.vue?vue&type=template&id=a48d5cbc&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationPlugin/Notification.vue?vue&type=template&id=a48d5cbc&scoped=true
// module id = 2791
// module chunks = 31